type ParcelLogoProps = React.SVGProps<SVGSVGElement>;

// "Parcel" wordmark. Sized purely via CSS — set `height` and let `width` stay
// auto so the viewBox drives the aspect ratio. No box, badge, or background so
// it reads as inline text alongside a heading.
function ParcelLogo({ style, ...props }: ParcelLogoProps) {
	return (
		<svg
			viewBox="0 0 57.4 14.94"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-label="Parcel"
			style={{ display: "block", ...style }}
			{...props}
		>
			<g>
				<path
					fill="#09273d"
					d="M2.91,14.9H.05V0H5.76A5.47,5.47,0,0,1,7.28.21,5.72,5.72,0,0,1,8.64.82a6,6,0,0,1,1.15.93A6.24,6.24,0,0,1,10.69,3a6.37,6.37,0,0,1,.57,1.43A5.85,5.85,0,0,1,11.47,6,6,6,0,0,1,11,8.28,6.21,6.21,0,0,1,9.8,10.17,5.83,5.83,0,0,1,8,11.45a5.36,5.36,0,0,1-2.22.47H2.91v3Zm0-12V8.57H5.76a2.75,2.75,0,0,0,1.11-.22,2.84,2.84,0,0,0,.9-.62,2.77,2.77,0,0,0,.62-.91,2.72,2.72,0,0,0,.22-1.11A2.78,2.78,0,0,0,8.39,4.6a3,3,0,0,0-.62-.91,2.81,2.81,0,0,0-.9-.61,2.75,2.75,0,0,0-1.11-.22Z"
				/>
				<path
					fill="#09273d"
					d="M28,14.9H25.24V4.24h.66l.9,1.27a4.68,4.68,0,0,1,1.49-.93A4.87,4.87,0,0,1,30,4.26h2.4V7H30a2.05,2.05,0,0,0-.81.16,1.83,1.83,0,0,0-.65.44A2,2,0,0,0,28,9Z"
				/>
				<path
					fill="#09273d"
					d="M42.8,6.16l-2,2a2.48,2.48,0,0,0-.41-.75,2.56,2.56,0,0,0-.58-.56,2.42,2.42,0,0,0-.7-.35,2.54,2.54,0,0,0-.78-.12,2.51,2.51,0,0,0-1.05.23,2.42,2.42,0,0,0-.85.64,3,3,0,0,0-.58,1,3.87,3.87,0,0,0-.2,1.26,2.75,2.75,0,0,0,.2,1,2.68,2.68,0,0,0,2.48,1.64,2.47,2.47,0,0,0,.77-.11,2.66,2.66,0,0,0,.69-.31,2.52,2.52,0,0,0,.58-.5,2.56,2.56,0,0,0,.41-.65l2,2a5.34,5.34,0,0,1-.87,1,5.82,5.82,0,0,1-1.06.72,5.91,5.91,0,0,1-1.21.46,5.57,5.57,0,0,1-1.3.15,5.33,5.33,0,0,1-2.11-.42,5.42,5.42,0,0,1-1.73-1.16,5.36,5.36,0,0,1-1.17-1.72,5.17,5.17,0,0,1-.43-2.11,6,6,0,0,1,.43-2.29A5.76,5.76,0,0,1,34.5,5.34a5.52,5.52,0,0,1,1.73-1.25,5,5,0,0,1,2.11-.46,5.23,5.23,0,0,1,1.31.17,5.48,5.48,0,0,1,1.23.5A5,5,0,0,1,42,5.09a4.72,4.72,0,0,1,.85,1.07"
				/>
				<path
					fill="#09273d"
					d="M48.21,12.09a1.16,1.16,0,0,0,.31.07h.32a2.47,2.47,0,0,0,.77-.11,2.39,2.39,0,0,0,.69-.31,2.52,2.52,0,0,0,.58-.5,2.31,2.31,0,0,0,.41-.65l2,2a5.34,5.34,0,0,1-.87,1,5.82,5.82,0,0,1-1.06.72,5.7,5.7,0,0,1-1.21.46,5.57,5.57,0,0,1-1.3.15,5.33,5.33,0,0,1-2.11-.42,5.32,5.32,0,0,1-2.9-2.94,5.76,5.76,0,0,1-.43-2.26A5.91,5.91,0,0,1,43.83,7,5.11,5.11,0,0,1,45,5.19,5.24,5.24,0,0,1,46.73,4a5.51,5.51,0,0,1,2.11-.41,5.73,5.73,0,0,1,1.31.16,5.91,5.91,0,0,1,1.21.46A5.79,5.79,0,0,1,52.43,5a5.34,5.34,0,0,1,.87,1Zm1.39-5.6a1.33,1.33,0,0,0-.37-.09l-.39,0a2.84,2.84,0,0,0-1.05.2,2.62,2.62,0,0,0-1.42,1.5,3.21,3.21,0,0,0-.21,1.2c0,.1,0,.21,0,.34s0,.25,0,.38a2.22,2.22,0,0,0,.09.37,1.33,1.33,0,0,0,.12.32Z"
				/>
				<rect fill="#09273d" x="54.67" width="2.74" height="14.9" />
				<path
					fill="#09273d"
					d="M22.52,4.06,21.46,5.33a6.79,6.79,0,0,0-1.72-1.21,5.07,5.07,0,0,0-1-.35,4,4,0,0,0-1-.13,5.38,5.38,0,0,0-2.12.41,5.12,5.12,0,0,0-1.73,1.16A5.56,5.56,0,0,0,12.71,7a6,6,0,0,0-.43,2.28,6.35,6.35,0,0,0,.43,2.38,5.26,5.26,0,0,0,1.17,1.77,5.11,5.11,0,0,0,1.73,1.1,6,6,0,0,0,2.12.37,4.44,4.44,0,0,0,1-.12,6.09,6.09,0,0,0,1-.36,5.53,5.53,0,0,0,.91-.53,8.67,8.67,0,0,0,.82-.65l1.06,1.47h.65V4.06Zm-1.63,7.08L18,12.83V9.45l.32-.19,2.61-1.5ZM14.51,7.77l1.11.64v.87l.54.27V8.73l1.26.72v3.36l-2.91-1.68Zm.17-.46,3-1.74,1.12.65L15.8,8ZM16.56,8.4l-.17-.09,3-1.74,1.3.74L18.81,8.4l-1.12.65Z"
				/>
				<polygon fill="#ffc107" points="18.81 6.22 15.8 7.96 14.68 7.31 17.69 5.57 18.81 6.22" />
				<polygon
					fill="#ffc107"
					points="20.7 7.31 18.81 8.4 17.69 9.05 16.56 8.4 16.39 8.31 19.4 6.57 20.7 7.31"
				/>
				<polygon
					fill="#ffc107"
					points="17.42 9.45 17.42 12.81 14.51 11.13 14.51 7.77 15.62 8.41 15.62 9.28 16.16 9.55 16.16 8.73 17.42 9.45"
				/>
				<polygon
					fill="#ffc107"
					points="20.89 7.76 20.89 11.14 17.96 12.83 17.96 9.45 18.28 9.26 20.89 7.76"
				/>
			</g>
		</svg>
	);
}

export default ParcelLogo;
